import NewPasswordForm from './NewPasswordForm';

export default NewPasswordForm;
